// removed by extract-text-webpack-plugin
module.exports = {"grid":"CentricUI__pages__CatalogDashboardPage__grid","rightPanel":"CentricUI__pages__CatalogDashboardPage__rightPanel","topBar":"CentricUI__pages__CatalogDashboardPage__topBar","splitter":"CentricUI__pages__CatalogDashboardPage__splitter","hidden":"CentricUI__pages__CatalogDashboardPage__hidden","open":"CentricUI__pages__CatalogDashboardPage__open","flexLayoutRootsWrapper":"CentricUI__pages__CatalogDashboardPage__flexLayoutRootsWrapper","mdi":"CentricUI__pages__CatalogDashboardPage__mdi","sdi":"CentricUI__pages__CatalogDashboardPage__sdi"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/catalog/pages/CatalogDashboardPage.css
// module id = 1639
// module chunks = 10